import React from 'react';
import CustomerDataSection from './CustomerDataSection';

const recordTypes = [
    { key: 'brand', label: 'Brand', icon: 'bi-tag' },
    { key: 'product', label: 'Products', icon: 'bi-box-seam' },
    { key: 'unit_of_measure', label: 'Units of Measure', icon: 'bi-rulers' },
    { key: 'storage_location_type', label: 'Storage Location Type', icon: 'bi-geo-alt' },
    { key: 'reconciliation_report_type', label: 'Reconciliation Report Type', icon: 'bi-file-earmark-bar-graph' },
    { key: 'sale_tag_value', label: 'Sale Tag Value', icon: 'bi-bookmark-star' },
    { key: 'sale_deletion_reason', label: 'Sale Deletion Reasons', icon: 'bi-trash' },
];

const AuditTrailMetadata = () => (
    <CustomerDataSection
        title="Audit Trail - Metadata"
        titleIcon="bi-database-gear"
        recordTypesLabel="Metadata Record Types"
        recordTypes={recordTypes}
    />
);

export default AuditTrailMetadata;
